var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyDarkblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff9d1e;}.b{fill:#324854;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1358 -829)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1358 829)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1362.25 835.375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.426 4.265)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.8,128.618a1.983,1.983,0,0,0-1.979-1.969h-4.186a2.285,2.285,0,0,0-2.011,1.2l-.291.537a2.222,2.222,0,0,1-.251,2.167,2.2,2.2,0,0,1,.844.247l1.168-2.154a.135.135,0,0,1,.254.064v13.919a1,1,0,1,0,2.007,0v-8.019h.433v8.02a1,1,0,0,0,2.007,0c0-12.956-.018-6.093-.018-14a.175.175,0,0,1,.35,0l.031,6.143a.836.836,0,0,0,.836.832h0a.836.836,0,0,0,.832-.84Z",
    transform: "translate(-334.086 -126.649)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.666,128.7a1.431,1.431,0,0,0-1.428-1.421H13a1.431,1.431,0,0,0-1.428,1.421c0,.244,0,.036-.007,1.185l-.665-.137s-1.489-4.1-2.022-5.648c-.392-1.139-1.048-1.717-1.951-1.717H4c-.9,0-1.56.578-1.951,1.717-.607,1.766-1.985,5.536-2,5.574a.844.844,0,0,0,1.585.58c.012-.032,1-2.739,1.677-4.653-.045.371.1-.41-1.2,6.284a.47.47,0,0,0,.46.559H3.22v6.121a1.013,1.013,0,1,0,2.025,0v-6.121h.437v6.121a1.013,1.013,0,1,0,2.025,0v-6.121h.644a.469.469,0,0,0,.46-.559c-1.3-6.695-1.153-5.913-1.2-6.284.676,1.913,1.665,4.621,1.677,4.653a.844.844,0,0,0,.761.553l1.99.409a.6.6,0,0,0,.725-.587s.01-1.695.011-1.9a.116.116,0,0,1,.233,0c0,1.626,0,9.441,0,10.117a.724.724,0,0,0,1.448,0v-5.788h.313v5.788a.724.724,0,0,0,1.448,0c0-4.162-.01-9.056-.013-10.143a.126.126,0,0,1,.252,0l.022,4.433a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6v0C17.684,132.212,17.67,129.528,17.666,128.7Z",
    transform: "translate(0 -122.383)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.194 0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.733,
    cy: 1.733,
    r: 1.733
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.05 5.288)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.573,
    cy: 1.573,
    r: 1.573
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.3,39.9a1.749,1.749,0,1,0,1.749,1.749A1.749,1.749,0,0,0,77.3,39.9Z",
    transform: "translate(-75.548 -39.898)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyDarkblue);
export default __webpack_public_path__ + "static/media/family_darkblue.131027568ba26448e36751d4d08cf340.svg";
export { ForwardRef as ReactComponent };